<template>
  <component :is="way"/>
</template>
<script>

  import {STORE_PREFIX} from '@/routes_new/outer/interview/landing/prepare/constants.js';

  import MaskOnVideoDefault from '@/components/VideoRecorder/maskOnVideo/default';
  const MaskOnVideoDanone = () => import(/* webpackChunkName: "danone" */'@/process/danone/components/VideoRecorder/maskOnVideo/index.vue');

  export default {
    name: 'mask-on-video',
    components: {
      MaskOnVideoDanone,
      MaskOnVideoDefault
    },
    computed: {
      way() {
        let way = 'mask-on-video';
        const process = this.$store.getters[STORE_PREFIX + 'interview/process'];
        if (process === 'danone') {
          return `${way}-${process}`;
        } else {
          return `${way}-default`;
        }
      }
    }
  }
</script>
